// @flow strict
import * as React from 'react';
import IntlContext from '../../services/intl/context.js';

import routeLoadingLabels from '../../services/routeLoading/labels.js';
import reloadPageOnClick from '../../services/routeLoading/reloadPage.js';

export function RouteLoading() {
  const { language } = React.useContext(IntlContext);
  return (
    <div role="status" aria-busy="true" style={{ padding: '32px' }}>
      {routeLoadingLabels(language).loading}
    </div>
  );
}

type Props = { children: React.Node, language: string };

// A stale tab or temporary chunk failure must leave a usable full-navigation retry.
export default class RouteLoadBoundary extends React.Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ padding: '32px' }}>
        <a
          onClick={reloadPageOnClick}
          href={typeof window === 'undefined' ? '/' : window.location.href}
        >
          {routeLoadingLabels(this.props.language).reload}
        </a>
      </div>
    );
  }
}
